import { PwResetForm } from '../components/forms/pw-reset-form';
import { Container } from '../components/layout/container';
import Layout from '../components/layout/layout';

const PwResetPage = () => (
  <Layout canonicalUrl='/profile'>
    <Container>
      <PwResetForm className='mt-10' />
    </Container>
  </Layout>
);

export default PwResetPage;
